export const mapboxAccessToken = 'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';
export const boundingBox = [-124.409180, 32.147130, -114.082031, 42.090580];

// Data service
const cdnDomains = {
    test: 'd2qkdo9nzbd6nz.cloudfront.net',
    dev: 'd1g1z8quwbkpl8.cloudfront.net',
    prod: 'd2qkdo9nzbd6nz.cloudfront.net'
}
export const cdnUrl = `https://${cdnDomains[process.env.BAKER_BUILD_ENV]}/combined/latest.topojson`;
